import Vue from 'vue'
const moment = require('moment')
require('moment/locale/es')

Vue.filter('uppercase', function (value) {
  if (!value) return ''
  return value.toString().toUpperCase()
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  const val = value.toString()
  return `${val[0].toUpperCase()}${val.substr(1)}`
})

Vue.filter('fecha_splitter', function (value) {
  let data = value.split(' ')
  const fecha = moment(data[0], 'YYYY-MM-DD').format('D MMM')
  return `${fecha} a las ${data[1].substr(0,5)}`
})

Vue.filter('date_format', function (value) {
  const date = moment(value).format('DD-MM-YYYY')
  return date
})

Vue.filter('phone_format', function (value) {
  if (!value) return '---'
  const v = value.split('')
  const a = v[0] + v[1]
  const b = v[2]
  const c = v[3] + v[4] + v[5] + v[6]
  const d = v[7] + v[8] + v[9] + v[10]
  return `+(${a}) ${b} ${c} ${d}`
})

Vue.filter('number', function(number){
  if (!number) return 0
  return number.toString()
      .replace(/^0/, '')
      .replace(/\./, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
})

Vue.filter('phone_format_short', function (value) {
  if (!value) return '---'
  const v = value.split('')
  const a = v[0]
  const b = v[1] + v[2] + [3] + v[4]
  const c = v[5] + v[6] + v[7] + v[8]
  return `+(56) ${a} ${b} ${c}`
})

Vue.filter('money', function (value) {
  return Number(value).toLocaleString('es')
})

Vue.filter('rutificador', function (value) {
  if (!value) return '---'
  let rut = value.split('').reverse().join('')
  let inverse = `${rut.slice(0, 1)}-${rut.slice(1, 4)}.${rut.slice(4, 7)}.${rut.slice(7, rut.length)}`
  return inverse.split('').reverse().join('')
})
